import React from "react";
import { useTheme } from "../../../components/hooks/useTheme";
import { Divider } from "@mui/material";
import { validateMin } from "../../../utils/validateMin";
import useGeneral from "../../../components/hooks/useGeneral";
import moment from "moment";

type Props = {
  summaryData: any;
  hourlyRate: string;
  setHourlyRate: (value: string) => void;
  dailyRate: string;
  setDailyRate: (value: string) => void;
  weeklyRate: string;
  setWeeklyRate: (value: string) => void;
  yearlyRate: string;
  setYearlyRate: (value: string) => void;
};

export default function RackRateDetails({
  summaryData,
  hourlyRate,
  setHourlyRate,
  dailyRate,
  setDailyRate,
  weeklyRate,
  setWeeklyRate,
  yearlyRate,
  setYearlyRate
}: Props) {
  const { themeStyles } = useTheme();
  const { dateFormat }: any = useGeneral();

  return (
    <div className="w-full">
      <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
        Rack rates details
      </span>

      <Divider className={`w-full ${themeStyles.divider.bg}`} />

      <div className="w-full my-3">
        <table className="min-w-full">
          <tbody className="text-left">
            <tr className={`border-b ${themeStyles.main.borderColor}`}>
              <th className={`w-[8%] text-[12px] font-semibold mb-2 pr-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>#</th>
              <th className={`w-[18%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Season</th>
              <th className={`w-[6%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Hours</th>
              <th className={`w-[6%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Days</th>
              <th className={`w-[6%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Weeks</th>
              <th className={`w-[6%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Months</th>
              <th className={`w-[17%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Base Hourly Price</th>
              <th className={`w-[17%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Base Daily Price</th>
              <th className={`w-[17%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Base Weekly Price</th>
              <th className={`w-[17%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Base Monthly Price</th>
              <th className={`w-[15%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Dates</th>
              <th className={`w-[8%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Was Manually Changed</th>
            </tr>

            <tr className={`border-b ${themeStyles.main.borderColor}`}>
              <td className="pr-[0.25rem] py-2 w-[8%]">
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                  {summaryData?.id}
                </span>
              </td>

              <td className="px-[0.25rem] py-2 w-[18%]">
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                  {
                    summaryData?.branchName
                  }
                </span>
              </td>

              <td className="px-[0.25rem] py-2 w-[6%]">
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                  {summaryData?.totalHours}
                </span>
              </td>

              <td className="px-[0.25rem] py-2 w-[6%]">
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                  {summaryData?.totalDays}
                </span>
              </td>

              <td className="px-[0.25rem] py-2 w-[6%]">
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                  {summaryData?.totalWeeks}
                </span>
              </td>

              <td className="px-[0.25rem] py-2 w-[6%]">
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                  {summaryData?.totalMonths}
                </span>
              </td>

              <td className="px-[0.25rem] py-2 w-[17%]">
                <input
                  type="number"
                  step={0.01}
                  min={0}
                  value={hourlyRate}
                  className={`w-full px-[5px] py-[5px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  onChange={(e) => {
                    setHourlyRate(validateMin(e.target.value, 0)?.toString());
                  }}
                />
              </td>

              <td className="px-[0.25rem] py-2 w-[17%]">
                <input
                  type="number"
                  step={0.01}
                  min={0}
                  className={`w-full px-[5px] py-[5px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={dailyRate}
                  onChange={(e) => {
                    setDailyRate(validateMin(e.target.value, 0)?.toString());
                  }}
                />
              </td>

              <td className="px-[0.25rem] py-2 w-[17%]">
                <input
                  type="number"
                  step={0.01}
                  min={0}
                  className={`w-full px-[5px] py-[5px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={weeklyRate}
                  onChange={(e) => {
                    setWeeklyRate(validateMin(e.target.value, 0)?.toString());
                  }}
                />
              </td>

              <td className="px-[0.25rem] py-2 w-[17%]">
                <input
                  type="number"
                  step={0.01}
                  min={0}
                  className={`w-full px-[5px] py-[5px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={yearlyRate}
                  onChange={(e) => {
                    setYearlyRate(validateMin(e.target.value, 0)?.toString());
                  }}
                />
              </td>

              <td className="px-[0.25rem] py-2 w-[15%]">
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                  {
                    moment(
                      new Date(
                        summaryData
                          ? summaryData?.pickupDate
                          : new Date()
                      )
                    ).format(dateFormat + " hh:mm a")
                  }
                </span>

                <br />

                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                  {
                    moment(
                      new Date(
                        summaryData
                          ? summaryData?.returnDate
                          : new Date()
                      )
                    ).format(dateFormat + " hh:mm a")
                  }
                </span>
              </td>

              <td className="pl-[0.25rem] py-2 w-[8%]">
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                  {summaryData?.wasRateManuallyChanged ? "Yes" : "No"}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
